/**
 * Loads and decodes images ahead of showing them. Always resolves: a failed
 * image must not hold back the UI waiting on it, it just paints late.
 *
 * @param {string[]} sources image URLs
 * @returns {Promise<void>}
 */
const preloadImages = (sources) =>
  Promise.all(
    sources.map((src) => {
      const img = new Image();
      img.src = src;
      return (img.decode ? img.decode() : Promise.resolve()).catch(() => {});
    })
  ).then(() => undefined);

export default preloadImages;
